/**
 * WARNING: the GMG_<Stage>_Config.json files are generated build artifacts.
 * They are regenerated from the stage definitions during the build/pipeline and bundled into the app.
 * Do not edit these generated files directly: manual changes are not the source of truth and will be overwritten.
 */
import { GMGAuth } from './GMGAuth';
import { loadStageConfig } from './stageConfig.js';
import AppSyncConfig from './AppSync';

const DevEndpoint = 'https://gmg-dev.aws.gmgcolor.com/v1/signed';

const local = {
    TrackJs: {
        token: 'd21da707471f4167af3941aea9b2e906',
        application: 'colorproofgo-devtest',
    },
    Tracking: {
        domain: 'gmg-dev.aws.gmgcolor.com',
        enabled: true,
        ignore: ['@gmgcolor', '@colorproof'],
    },
    Auth: {
        region: 'eu-central-1',
        userPoolId: 'eu-central-1_E2tf3yd45',
        userPoolWebClientId: '7rev0e2crj88iheavtv2r4ovpi',
    },
    CognitoHostedUIAuth: {
        region: 'eu-central-1',
        userPoolId: 'eu-central-1_1CiNIszlj',
        userPoolWebClientId: 'cb2ijjap0v84g1tsjlpphka3d',
        oauth: {
            domain: 'signin.dev.cdp.aws.gmgcolor.com',
            scope: ['email', 'openid', 'profile'],
            redirectSignIn: 'http://localhost:3000',
            redirectSignOut: 'http://localhost:3000',
            responseType: 'code',
        },
        roleArn: 'arn:aws:iam::873185113971:role/GMG_Dev_AuthenticatedCustomer',
    },
    API: {
        endpoints: [
            {
                name: 'SignedAPI',
                endpoint: DevEndpoint,
                region: 'eu-central-1',
            },
        ],
    },
    JobPreviewImageApi: {
        baseUrl: 'https://gmg-dev.aws.gmgcolor.com',
    },
    FeatureFlags: {
        enablePriorityButton: true,
    },
    GMGManage: {
        baseUrl: 'https://dev.cdp.aws.gmgcolor.com/',
    },
};

const modules = import.meta.glob('../../../graphql/GMG_*_Config.json', {
    eager: true,
    import: 'default',
});

const pathMap = {
    Dev: '../../../graphql/GMG_Dev_Config.json',
    Test: '../../../graphql/GMG_Test_Config.json',
    Prod: '../../../graphql/GMG_Prod_Config.json',
};

let config = loadStageConfig(modules, pathMap, 'config', local, 'Amplify');

function toAmplifyV6AuthConfig(cognitoConfig) {
    const { oauth = {} } = cognitoConfig;

    return {
        Cognito: {
            // Identity pools are unused: clients authenticate with the user pool only.
            // Do not pass identityPoolId even if generated stage JSON still has it —
            // Amplify fetchAuthSession() would then also call GetCredentialsForIdentity,
            // and a pool/client mismatch would throw and break token refresh / recovery.
            userPoolId: cognitoConfig.userPoolId,
            userPoolClientId: cognitoConfig.userPoolWebClientId,
            loginWith: {
                oauth: {
                    domain: oauth.domain,
                    scopes: oauth.scope || oauth.scopes || [],
                    redirectSignIn: [oauth.redirectSignIn],
                    redirectSignOut: [oauth.redirectSignOut],
                    responseType: oauth.responseType,
                },
            },
        },
    };
}

// When running the local dev server against Dev or Test, redirect back to
// localhost so the oauth flow doesn't send the browser to the deployed domain.
// For Prod, use the prod domain oauth config (don't override for dev server against prod).
if (import.meta.env.DEV && (import.meta.env.VITE_APP_STAGE === 'Dev' || import.meta.env.VITE_APP_STAGE === 'Test')) {
    config.CognitoHostedUIAuth = {
        ...config.CognitoHostedUIAuth,
        oauth: {
            ...config.CognitoHostedUIAuth.oauth,
            redirectSignIn: 'http://localhost:3000',
            redirectSignOut: 'http://localhost:3000',
        },
    };
}

// Generated config is still v3-shaped. In v3 we replaced config.Auth with
// config.CognitoHostedUIAuth and attached oauth directly to config.Auth.
// In v6, config.Auth is reserved for Amplify.configure's Auth.Cognito shape,
// so the original hosted-auth metadata is kept separately for GMGAuth.
const hostedAuthConfig = config.CognitoHostedUIAuth;
config.Auth = toAmplifyV6AuthConfig(hostedAuthConfig);
config.GMGHostedAuth = hostedAuthConfig;

config.API.endpoints[0]['custom_header'] = async () => {
    const idToken = await GMGAuth.getInstance().getIdToken();
    return {
        Authorization: idToken,
    };
};

// Amplify v6 GraphQL client reads endpoint/region/auth from this block.
config.API.GraphQL = {
    endpoint: AppSyncConfig.url,
    region: AppSyncConfig.region,
    defaultAuthMode: 'userPool',
};

export default config;
